define('services/utils',[], function () {
    "use strict";

    function isArray(object) {
        return object && object.constructor.toString().indexOf("Array") > -1;
    }

    function cloneProperties(object, clonedObject) {
        for (var property in object) {
            if (object.hasOwnProperty(property)) {
                if (isArray(object[property])) {
                    clonedObject[property] = object[property].slice(0);
                } else if (typeof object[property] === "object") {
                    clonedObject[property] = {};
                    cloneProperties(object[property], clonedObject[property]);
                } else {
                    clonedObject[property] = object[property];
                }
            }
        }
    }

    function getValueOrEmptyObject(value) {
        return value === undefined ? {} : value;
    }

    function addNewField(result, field, newFields) {
        result[field] = getValueOrEmptyObject(result[field]);
        for (var property in newFields[field]) {
            if (newFields[field].hasOwnProperty(property)) {
                result[field][property] = newFields[field][property];
            }
        }
    }

    return {
        addFields: function (newFields, defaultFields) {
            var result = defaultFields || this.defaultFields || {};
            for (var field in newFields) {
                if (newFields.hasOwnProperty(field)) {
                    addNewField(result, field, newFields);
                }
            }
            return result;
        },

        clone: function (object) {
            var clonedObject = {};
            cloneProperties(object, clonedObject);
            return clonedObject;
        }
    };
});
